import axios from 'axios';
import { IdVersion, RelazioneMedicaResponsabilitaCreateCommand, RelazioneMedicaResponsabilitaUpdateCommand, RelazioneMedicaResponsabilita } from '../types';
import { utilityService } from './common/utility-service';

const baseUrl = '/api/v1/relazione-medica-responsabilita';

export const getByKey = async (id: number): Promise<RelazioneMedicaResponsabilita> => {
    return (await axios.get(`${baseUrl}/${id}`)).data;
};
export const getByRelazioneMedica = async (id: number, assicurato: boolean): Promise<RelazioneMedicaResponsabilita[]> => {
    return (await axios.get(`${baseUrl}/relazione-medica/${id}/${assicurato}`)).data;
};

export const create = async (command: RelazioneMedicaResponsabilitaCreateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/create`, command)).data;
};

export const update = async (command: RelazioneMedicaResponsabilitaUpdateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/update`, command)).data;
};

export const remove = async (items: IdVersion[]): Promise<void> => {
    return (await axios.delete(`${baseUrl}/remove?${utilityService.toQueryStringMultiple(items)}`)).data;
};
